import { useState } from 'react';
import { Grid, Typography, Container } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

import { checkEmail } from '../../actions/users';
import { loginRed, loginFacebook } from '../../actions/auth';
import { isEmpty } from '../../components/common/helpers';
import { errorDeContrasena } from '../../utils/contrasena';
import { useDestinoAlEntrar } from '../../utils/destinoAlEntrar';
import SignUpForm from '../../components/auth/SignUpForm';

import { useDispatch, useSelector } from 'react-redux';

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  // Al crear la cuenta con Google o Facebook regresa adonde iba (con correo, «Entrar» del último paso lo lleva al login, que hace lo mismo)
  const destino = useDestinoAlEntrar(isAuthenticated);

  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});

  const guardar = async (data, terminos, privacidad) => {
    const arrError = {};
    if(isEmpty(data.username)){
      arrError.username = "Ingrese un nombre de usuario";
    } 
    if(isEmpty(data.email)){
      arrError.email = "Ingrese un email";
    }
    const validateEmail = data.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

    if(!validateEmail) {
      arrError.email = "Debe ser un email válido";
    }
    let check = await checkEmail(data.email);
    if(check){
      return setError({
        email: "El email ya existe"
      });
    }

    if(isEmpty(data.tel) || data.tel.length < 10){
      arrError.tel = "Debe de poner un teléfono con 10 digitos";
    }

    // Lo mismo que pide el servidor: antes pasaban 5 y la cuenta no se creaba hasta el final, ya con el código puesto
    const errorPass = isEmpty(data.pass) ? "Ingresa una contraseña" : errorDeContrasena(data.pass);
    if(errorPass){
      arrError.pass = errorPass;
    }

    if(data.pass !== data.confirmarPass){
      arrError.pass = "No coincide las contraseñas",
      arrError.confirmarPass = "No coincide las contraseñas"
    }

    if(!privacidad){
      arrError.politicas = "Acepta la política de privacidad";
    }

    if(!terminos){
      arrError.terminos = "Acepta los términos y condiciones";
    }

    if(Object.keys(arrError).length >=  1 || (!isEmpty(arrError.terminos) || !isEmpty(arrError.politicas)) ){
      return setError(arrError);
    }
    setDisable(true);

    const info = data;
    info.terminos = terminos;
    info.politicas = privacidad;
    info.num =  data.prefijo + data.tel
    navigate('/signup-step2', { state: { info }})
  }

  const responseGoogle = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      try {
        localStorage.setItem('access_token', credentialResponse.access_token);
        // Usar el access_token para obtener los datos del usuario
        const userInfo = await axios.get(
          'https://www.googleapis.com/oauth2/v1/userinfo?alt=json',
          {
            headers: {
              Authorization: `Bearer ${credentialResponse.access_token}`,
              Accept: 'application/json',
            },
          }
        );
        // El servidor comprueba el token con Google y toma de ahí el correo y el nombre. Los demás campos solo
        // los lee el servidor anterior (que no verificaba nada); se pueden quitar cuando el nuevo esté desplegado.
        const data = {
          accessToken: credentialResponse.access_token,
          email: userInfo.data.email,
          name: userInfo.data.given_name,
          apellido: userInfo.data.family_name,
        };
        await dispatch(loginRed(data));
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
   
    },
    onError: () => {
      console.log('Login Failed');
    },
  });

  // El SDK de Facebook devuelve { accessToken, userID, ... }. Solo mandamos el accessToken;
  // el backend lo verifica con el Graph API y obtiene el email/nombre reales.
  const responseFacebook = response => {
    if (!response?.accessToken) return;
    dispatch(loginFacebook(response.accessToken));
  }

  //Redirect (`replace`: el registro no se queda en el historial)
  if(isAuthenticated){
    return <Navigate to={destino} replace />
  }

  return (
    <Container sx={{
      flex: 1, // Ocupa el espacio disponible entre el header y el footer
      display: 'flex',
      alignItems: { xs: 'flex-start', md: 'center' }, // Center vertically on md+, start on mobile
      justifyContent: 'center',
    }}>
      <Grid container size={12} spacing={5}>
        <Grid className="logo" size={{ xs: 12, md: 6 }}>
          <img width="400" src="/logo-os-24.svg" alt="OneService" />
          <Typography variant='h3' color="primary" mt={3}>
            "Encuentra y ofrece servicios en un solo lugar."
          </Typography>
        </Grid>
        {/*Formulario de crear cuenta*/}
        <SignUpForm
          guardar={guardar}
          google={responseGoogle}
          facebook={responseFacebook}
          error={error}
          disable={disable}
        />
      </Grid>
    </Container>
  );
}

export default SignUp;